import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DeleteIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M17 5V4a3 3 0 0 0-1-2 3 3 0 0 0-2-1h-4a3 3 0 0 0-2 1 3 3 0 0 0-1 2v1H3a1 1 0 0 0 0 2h1v13a3 3 0 0 0 1 2 3 3 0 0 0 2 1h10a3 3 0 0 0 2-1 3 3 0 0 0 1-2V7h1a1 1 0 1 0 0-2h-4ZM9.3 3.3A1 1 0 0 0 9 4v1h6V4a1 1 0 0 0-.3-.7A1 1 0 0 0 14 3h-4a1 1 0 0 0-.7.3ZM6 7v13l.3.7.7.3h10l.7-.3.3-.7V7H6Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default DeleteIcon;
